import { render, staticRenderFns } from "./gaishoujihao.vue?vue&type=template&id=6039ad28&scoped=true"
import script from "./gaishoujihao.vue?vue&type=script&lang=js"
export * from "./gaishoujihao.vue?vue&type=script&lang=js"
import style0 from "./gaishoujihao.vue?vue&type=style&index=0&id=6039ad28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6039ad28",
  null
  
)

export default component.exports